import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { commafy } from 'helpers/number';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import { Image } from 'components/Image/Image';
import { Link } from 'components/navigation/Link/Link';

const PersonalLoanPrequalHighCcDebtView = props => {
  const { creditInfo } = props;
  return (
    <FlexContainer
      className={
        'flex-container system_neutral_n000 grayShadow16 margt12 border-rad8px padT40 padB48 m-padT20 m-padT24'
      }
    >
      <Row className={'format100 mobilePad8'}>
        <FlexContainer className={'flex-column '}>
          <FlexContainer className={'format100 justify-between'}>
            <FlexContainer className={'align-self-center m-hide t-hide'}>
              <Image className={'personalLoanBannerImg'} />
            </FlexContainer>
            <FlexContainer className={'flex-column'}>
              <FlexContainer className={'flex-column'}>
                <Label className="text-16 bold system_neutral_n400_text">
                  {'Pay this down with a personal loan'}
                </Label>
                <Label
                  type="Body-2"
                  className={
                    'text-12 m-text14 bold m-margt10 bold system_neutral_n400_text'
                  }
                >
                  {'REPORTED CREDIT BALANCES'}
                </Label>
                <Label
                  type="Body-2"
                  className={
                    'text-16 m-text18 bold margt10 system_neutral_n400_text'
                  }
                >
                  $
                  {commafy(creditInfo?.debtAnalysis?.creditCardDebt?.totalDebt)}
                </Label>
                <Label
                  type="Body-2"
                  className={'text-14 margtb10 system_neutral_n400_text'}
                >
                  <Link
                    className="secondary_text_light"
                    onClickCallback={props.onClickPrequal}
                  >
                    See if you're pre-qualified instantly
                  </Link>
                  {` with no impact to your credit score`}
                </Label>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer
              className={'align-self-center  flex-row m-hide t-hide'}
            >
              <Button
                mrphType="primary"
                onClick={props.onClickPrequal}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14'}
                  tabIndex="-1"
                >
                  {'Check Pre-Qualification'}
                </Label>
              </Button>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer className={'justify-between d-hide'}>
            <Image imgClass={'personalLoanBannerImg'} />
            <FlexContainer className={'align-self-center margt10 m-margt10'}>
              <Button
                mrphType="primary"
                onClick={props.onClickPrequal}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14 padlr30'}
                  tabIndex="-1"
                >
                  {'Check Pre-Qualification'}
                </Label>
              </Button>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </FlexContainer>
  );
};

export default PersonalLoanPrequalHighCcDebtView;
